import { defineMessages } from 'react-intl'

const scope = `procurify.platform.integrations.features.list-active-users-with-slack`

export default defineMessages({
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Active users with Slack linking status',
  },
  procurifyUserColumnHeader: {
    id: `${scope}.procurifyUserColumnHeader`,
    defaultMessage: 'Procurify user',
  },
  slackUserColumnHeader: {
    id: `${scope}.slackUserColumnHeader`,
    defaultMessage: 'Slack user',
  },
  unlinkUserAction: {
    id: `${scope}.unlinkUserAction`,
    defaultMessage: 'Unlink user',
  },
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Search users...',
  },
  emptyStateText: {
    id: `${scope}.emptyStateText`,
    defaultMessage: 'No active users found',
  },
})
